<template>
  <div class="item-selector">
    <div class="">
      <div v-if="item.item_id" class="selected-item">
        {{ item.name }}

        <!-- <span class="deselect-icon" @click="deselectItem">
          <font-awesome-icon icon="times-circle" />
        </span> -->
      </div>
      <base-select
        v-else
        ref="baseSelect"
        v-model="itemSelect"
        :options="items"
        :show-labels="false"
        :preserve-search="true"
        :initial-search="item.name"
        :invalid="invalid"
        :placeholder="$t('invoices.item.select_an_item')"
        label="name"
        class="multi-select-item"
        @value="onTextChange"
        @select="(val) => $emit('select', val)"
      >
        <template #option="{ option }">
          <div @mouseover="showItemInfo(option)" @click="selectItem(option)">
            {{ option.name }}
            <div v-if="hoveredOption === option" class="item-info">
              <p>Name: {{ option.name }}</p>
              <p>Part: {{ option.part_number }}</p>
              <p>Price: {{ formatPrice(option.price) }}</p>

            </div>
          </div>
        </template>
        <div slot="afterList">
          <button type="button" class="list-add-button" @click="openItemPage ">
            <font-awesome-icon class="icon" icon="cart-plus" />
            <label>{{ $t('general.add_new_item') }}</label>
          </button>
        </div>
      </base-select>
      <div class="item-description">
        <base-text-area
          v-autoresize
          v-model="item.description"
          :invalid-description="invalidDescription"
          :placeholder="$t('invoices.item.type_item_description')"
          type="text"
          rows="1"
          class="description-input"
          @input="$emit('onDesriptionInput')"
        />
        <div v-if="invalidDescription">
          <span class="text-danger">{{ $tc('validation.description_maxlength') }}</span>
        </div>
        <!-- <textarea type="text" v-autoresize rows="1" class="description-input" v-model="item.description" placeholder="Type Item Description (optional)" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    invalid: {
      type: Boolean,
      required: false,
      default: false
    },
    invalidDescription: {
      type: Boolean,
      required: false,
      default: false
    },
    taxPerItem: {
      type: String,
      default: ''
    },
    taxes: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      itemSelect: null,
      loading: false,
      type: '',
      addItemButtonShow: true,
      hoveredOption: null
    }
  },
  computed: {
    ...mapGetters('item', [
      'items'
    ]),
    ...mapGetters('invoice', [
    ])
  },
  watch: {
    invalidDescription (newValue) {
    }
  },
  created () {
    // this.InvoiceType()
  },
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('item', [
      'fetchItems'
    ]),
    InvoiceType () {
      if (this.$route.name === 'invoices.edit') {
        this.addItemButtonShow = false
      }
    },
    async searchItems (search) {
      let data = {
        filter: {
          name: search,
          unit: '',
          price: '',
          part_number: ''
        },
        orderByField: '',
        orderBy: '',
        pagination: 'no'
      }

      this.loading = true
      if (this.$route.name === 'invoices.edit') {
        await this.fetchItems(data)
      }

      this.loading = false
    },
    onTextChange (val) {
      this.searchItems(val)

      this.$emit('search', val)
    },
    openItemPage () {
      this.$router.push({ path: '/supplier/items/create' })
    },
    deselectItem () {
      this.itemSelect = null
      this.$emit('deselect')
    },
    showItemInfo (option) {
      this.hoveredOption = option
    },

    selectItem (option) {
      this.itemSelect = option
      this.$emit('select', option)
    },
    formatPrice (price) {
      return (price).toFixed(2)
    }
  }
}
</script>
